import { L_Body, L_Container, L_Icon, L_InstrumentText, logotypeContainerVariants } from "./Logotype.styled";
import { getIconInstrument } from "../../../../../../helpers";
import { observer } from "mobx-react";
import { useStores } from "../../../../../../stores";

interface LogotypeProps {}

export const Logotype = observer(({}: LogotypeProps) => {
	const { grandCharts } = useStores();
	const { selected } = grandCharts;

	return (
		<L_Container $service={selected.service.slug} variants={logotypeContainerVariants}>
			<L_Body>
				<L_Icon>{getIconInstrument(selected.instrument.slug, true)}</L_Icon>
				<L_InstrumentText>
					Grand
					<br /> Chart
				</L_InstrumentText>
			</L_Body>
		</L_Container>
	);
});
